var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',[_c('header-name',[_vm._v("Edit accident report")]),_vm._v(" "),_c('breadcrumbs',{attrs:{"items":_vm.bread}}),_vm._v(" "),_c('div',{staticClass:"mt-8"},[_c('accident-report-form',{on:{"submitForm":_vm.edit},model:{value:(_vm.form),callback:function ($$v) {_vm.form=$$v},expression:"form"}})],1)],1)
}
var staticRenderFns = []

export { render, staticRenderFns }